import {
    apiRequest,
    verList
} from "../../../../../services/adapters/kepegawaian/verificationCancelPresensiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", verList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository